<template>
  <h4 class="vertical-center mb-0 text-white">{{ currentDate }} {{ currentTime }}</h4>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'Clock',
    data() {
      return {
        currentTime: '',
        currentDate: '',
        clockIntervalId: '',
      };
    },
    mounted() {
      this.fetchTime();
      this.pollTime();
    },
    beforeDestroy() {
      clearInterval(this.clockIntervalId);
    },
    methods: {
      pollTime() {
        this.clockIntervalId = setInterval(() => {
          this.fetchTime();
        }, 1000);
      },
      fetchTime() {
        const now = new Date();
        this.currentDate = moment(now).format('DD/MM/YYYY');
        this.currentTime = moment(now).format('HH:mm');
      },
    },
  };
</script>
